module.exports = __webpack_public_path__ + "img/MunicipioIbge.2df92d8b.png";